<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_KNOX_ID')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <cmp-user-select
              ref="userSelect"
              :selectedUser="selectedUser"
              @selected="userSelect"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="nickNameUseYn"
              :selected="searchFrame.nickNameUseYn"
              defaultOption="all"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              v-permission:read="this.$options.name"
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ this.$t('MSG_BTN_RESET') }}
            </sui-button>
            <sui-button
              v-permission:read="this.$options.name"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ this.$t('MSG_BTN_SEARCH') }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'ds0'"
        :multiselect="false"
        :columnsautoresize="true"
        :autoheight="false"
        :showDisplayCountControl="false"
        :columnsresize="true"
        :initialPagesize="10"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            v-permission:create="this.$options.name"
            type="button"
            class="comm_btn_gridTop"
            @click="onAddRowClick"
          >
            {{ this.$t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            v-permission:delete="this.$options.name"
            type="button"
            class="comm_btn_gridTop"
            @click="onDelRowClick"
          >
            {{ this.$t('MSG_BTN_ROW_DEL') }}
          </sui-button>
          <sui-button
            v-permission:update="this.$options.name"
            type="button"
            class="comm_btn_gridTop"
            @click="onCancelClick"
          >
            {{ this.$t('MSG_BTN_CANCEL') }}
          </sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="this.$options.name"
            type="button"
            class="comm_btn_gridTop  comm_ico_excel"
            @click="onExcelDownloadClick"
          >
            {{ this.$t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:update="this.$options.name"
          type="button"
          class="comm_btn_solid"
          :disabled="saveFlag"
          @click="onSaveClick"
        >
          {{ this.$t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00027', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      searchFrame: {
        nickNameUseYn: {
          label: '',
          key: '',
        },
        knoxId: '',
      },
      selectedUserId: '',
      selectedUser: {
        epId: '',
        siteName: '',
        employeeIDNumber: '',
        userName: '',
        companyName: '',
        departmentName: '',
        knoxId: '',
        servedStateCode: '',
        userId: '',
        epid: '',
        email: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_SEL'),
        datafield: 'selectYn',
        createwidget: (row, column, value, htmlElement) => {
          const instance = utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {
          }, this.ds0, this.$refs.grid);
          instance.getComponentInstance().$on('input', () => {
            const rowindex = instance.getDatasetIndex();
            this.selectRows(rowindex);
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_EMPL_NM'),
        datafield: 'userName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
            checkEditableFunction: this.textFieldEditableState,
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_USER_CONNECTION_NO'),
        datafield: 'userNickName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: 20,
            checkEditableFunction: this.textFieldEditableState,
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MANAGER_YN'),
        datafield: 'userNickNameManagerYn',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'nickNameUseYn',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'm_dsplLngId',
              knoxId: 'm_knoxId',
              userName: 'm_userName',
              userGlobalName: 'm_userGlobalName',
              departmentName: 'm_departmentName',
              departmentEnglishName: 'm_departmentEnglishName',
            },
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.ds0, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: '150px',
      }],
      indexes: [],
      searchFlag: false,
      originalDataLength: 0,
      dataLength: 0,
    };
  },
  computed: {
    saveFlag() {
      return !this.searchFlag || this.dataLength === 0;
    },
    addRowFlag() {
      return this.dataLength !== this.originalDataLength;
    },
  },
  watch: {},
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'deleteYn', map: 'deleteYn' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'firstRegistrationProgramId', map: 'firstRegistrationProgramId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'finalModificationProgramId', map: 'finalModificationProgramId' },
      { type: 'string', name: 'originalFinalModificationDTM', map: 'originalFinalModificationDTM' },
      { type: 'string', name: 'userId', map: 'userId' },
      { type: 'string', name: 'userNickName', map: 'userNickName' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userNickNameManagerYn', map: 'userNickNameManagerYn' },
      { type: 'string', name: 'nickNameUseYn', map: 'nickNameUseYn' },
      { type: 'string', name: 'finalModificationUserInfo', map: 'finalModificationUserInfo' },
      { type: 'string', name: 'm_dsplLngId', map: 'm_dsplLngId' },
      { type: 'string', name: 'm_knoxId', map: 'm_knoxId' },
      { type: 'string', name: 'm_userName', map: 'm_userName' },
      { type: 'string', name: 'm_userGlobalName', map: 'm_userGlobalName' },
      { type: 'string', name: 'm_departmentName', map: 'm_departmentName' },
      { type: 'string', name: 'm_departmentEnglishName', map: 'm_departmentEnglishName' },
      { type: 'string', name: 'selectYn', map: 'selectYn' },
    ],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    userSelect(selected) {
      if (utils.isEmpty(selected)) {
        this.reset();
        return;
      }
      const { userId, knoxId } = selected;
      if (utils.isEmpty(knoxId)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_EXIST_KNOX_ID_ON_ACC'), null, this.userSelectReset);
      } else {
        this.selectPublicIdCheck(knoxId).then(res => {
          if (res.data > 0) {
            this.searchFrame.knoxId = knoxId;
            this.selectedUserId = userId;
          } else {
            utils.messageBox('information', this.$t('MSG_ALT_NOT_BSPT_ACO'), null, this.userSelectReset);
          }
        }).catch(error => {
          console.log(error);
        });
      }
    },
    selectPublicIdCheck(knoxId) {
      return new Promise((resolve, reject) => {
        http.request(this.$options.name, 'DTS_CMY_00067', {
          query: { knoxId },
        }).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    onResetClick() {
      this.reset();
      this.$refs.nickNameUseYn.reset();
      this.userSelectReset();
    },
    reset() {
      this.ds0.setRawData([]);
      this.indexes = [];
      this.searchFlag = false;
      this.searchFrame.knoxId = '';
      this.selectedUserId = '';
      this.originalDataLength = 0;
      this.dataLength = 0;
    },
    userSelectReset() {
      utils.forEach(this.selectedUser, (value, key) => {
        this.selectedUser[key] = '';
      });
      this.$refs.userSelect.setValue(this.selectedUser);
    },
    datasetRowTemplate() {
      return [{
        userId: '',
        userName: '',
        userNickName: '',
        userNickNameManagerYn: 'N',
        nickNameUseYn: 'Y',
        finalModificationDTM: '',
        selectYn: 'N',
      }];
    },
    onAddRowClick() {
      if (this.searchFlag) {
        this.ds0.addRows(this.datasetRowTemplate());
        this.$refs.grid.setFocus(this.ds0.data.length - 1, 'userName');
        this.dataLength = this.ds0.data.length;
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_SRCH_AFTER_BTN_CLICK'));
      }
    },
    onDelRowClick() {
      if (this.searchFlag) {
        this.ds0.deleteRows(this.indexes);
        this.indexes = [];
        this.dataLength = this.ds0.data.length;
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_SRCH_AFTER_BTN_CLICK'));
      }
    },
    onCancelClick() {
      if (this.searchFlag) {
        this.ds0.reset();
        this.dataLength = this.originalDataLength;
        this.indexes = [];
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_SRCH_AFTER_BTN_CLICK'));
      }
    },
    textFieldEditableState(rowData) {
      return utils.isEmpty(rowData) ? true : utils.isEmpty(rowData.finalModificationDTM);
    },
    getSearchData() {
      const data = {};
      utils.forEach(this.searchFrame, (value, key) => {
        if (utils.isEqual(key, 'knoxId')) {
          data[key] = value;
        } else {
          data[key] = value.key;
        }
      });
      return data;
    },
    onSearchClick() {
      const searchData = this.getSearchData();
      if (utils.isEmpty(searchData.knoxId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_KNOX_ID')));
      } else {
        http.request(this.$options.name, 'DTS_CMY_00064', {
          query: searchData,
        }).then(res => {
          this.searchFlag = true;
          this.ds0.setRawData(this.setUserInfoFormat(res.data));
          this.originalDataLength = this.ds0.data.length;
          this.dataLength = this.originalDataLength;
        }).catch(error => {
          console.log(error);
        });
      }
    },
    setUserInfoFormat(list) {
      utils.forEach(list, data => {
        const result = {};
        utils.forEach(data.finalModificationUserInfo, (value, key) => {
          result[`m_${key}`] = value;
        });
        if (!utils.isEmpty(result)) {
          utils.assign(data, result);
        }
      });
      return list;
    },
    selectRows(rowindex) {
      if (utils.indexOf(this.indexes, rowindex) === -1) {
        this.indexes.push(rowindex);
      } else {
        utils.pullAll(this.indexes, [rowindex]);
      }
    },
    getSaveData() {
      const added = this.ds0.getAddedRows();
      const saveList = this.ds0.getUpdatedRows();
      utils.forEach(added, data => {
        const rowData = utils.find(this.ds0.data, { 'dataset-row-id': data['dataset-row-id'] });
        saveList.push(utils.assign(data, rowData));
      });
      return saveList;
    },
    onSaveClick() {
      const saveData = this.getSaveData();
      const result = this.validation(saveData);
      if (result.valid) {
        if (this.addRowFlag) {
          this.nickNameDuplicateCheck(saveData).then(res => {
            const { userNickName } = res.data;
            if (utils.isEmpty(userNickName)) {
              this.saveAction(saveData);
            } else {
              utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_DUP_NCELL'), userNickName));
            }
          }).catch(error => {
            console.log(error);
          });
        } else {
          this.saveAction(saveData);
        }
      } else {
        utils.messageBox('warning', result.msg, null, () => {
          this.$refs.grid.setFocus(result.row, result.column);
        });
      }
    },
    validation(saveData) {
      const original = this.ds0.originalData.length;
      const result = {
        valid: true,
        msg: '',
        row: 0,
        column: '',
      };
      utils.forEach(saveData, (data, index) => {
        if (utils.isEmpty(data.userName)) {
          result.valid = false;
          result.row = original + index;
          result.msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), result.row + 1, this.$t('MSG_TXT_EMPL_NM'));
          result.column = 'userName';
          return false;
        }
        if (utils.isEmpty(data.userNickName)) {
          const rowindex = original + index + 1;
          result.valid = false;
          result.row = original + index;
          result.msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), rowindex, this.$t('MSG_TXT_USER_CONNECTION_NO'));
          result.column = 'userNickName';
          return false;
        }
        return true;
      });
      return result;
    },
    saveAction(saveData) {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00065', {
          path: { 'user-id': this.selectedUserId },
          data: saveData,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    nickNameDuplicateCheck(saveData) {
      const userNickNameList = [];
      utils.forEach(saveData, data => {
        if (utils.isEmpty(data.userId)) {
          userNickNameList.push(data.userNickName);
        }
      });
      return new Promise((resolve, reject) => {
        http.request(this.$options.name, 'DTS_CMY_00066', {
          query: {
            userNickNameList: utils.join(userNickNameList, '|'),
          },
        }).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    research() {
      this.ds0.submit();
      this.onSearchClick();
    },
    onExcelDownloadClick() {
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `${this.searchFrame.knoxId}_${sToday}.xlsx`;
      if (this.ds0.data.length > 0) {
        utils.downloadGridToExcel(this.$options.name, this.gridColumns0, this.ds0, sExcelName);
      }
    },
  },
};
</script>
<style scoped>
</style>
